module.exports = __webpack_public_path__ + "static/media/bxl-twitter.c6b199de.svg";